﻿import { NgModule } from '@angular/core';
import {
    MatButtonModule,
    MatCheckboxModule,
    MatToolbarModule,
    MatCardModule,
    MatInputModule,
    MatProgressBarModule,
    MatProgressSpinnerModule
} from '@angular/material';
import { FlexLayoutModule } from "@angular/flex-layout";
import { ngfModule } from "angular-file";


@NgModule({
    imports: [
        MatButtonModule,
        MatCheckboxModule,
        MatToolbarModule,
        MatCardModule,
        MatInputModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        FlexLayoutModule,
        ngfModule
    ],
    exports: [
        MatButtonModule,
        MatCheckboxModule,
        MatToolbarModule,
        MatCardModule,
        MatInputModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        FlexLayoutModule,
        ngfModule
    ]
})
export class SharedModule { }